import { Layout } from "./Layout";
import { staticContent } from "./staticContent";

export const PostRegistration = () => {
  return (
    <Layout
      {...staticContent.globalContent}
      {...staticContent.postRegistration}
      registered
    />
  );
};
